// 简单的事件总线，用于主题切换时通知图表重新渲染
const listeners = {}

export default {
  on(event, callback) {
    if (!listeners[event]) {
      listeners[event] = []
    }
    listeners[event].push(callback)
  },
  off(event, callback) {
    if (!listeners[event]) return
    listeners[event] = listeners[event].filter(cb => cb !== callback)
  },
  emit(event, ...args) {
    if (!listeners[event]) return
    listeners[event].forEach(callback => callback(...args))
  }
}
